import { $api } from "../AxiosInstance";

export class MigrationService {
  static async downloadMigration() {
    return await $api.get("/api/migration/project/download");
  }

  static async uploadMigration(body) {
    return await $api.post("/api/migration/project/upload", { ...body });
  }

  static async renewDB() {
    return await $api.get("/api/test/fixPrices");
  }
}
